import { useTab } from '@/common/entityFramework/entityTabs/TabContext';
import { BooleanSelect } from './BooleanSelect';
import { CodeFormField } from './CodeFormField';
import { DateFormField } from './DateFormField';
import { DropdownSelect } from './DropdownSelect';
import { EntitySelect } from './EntitySelect';
import { EnumSelect } from './EnumSelect';
import { InstantFormField } from './InstantFormField';
import { MoneyFormField } from './MoneyFormField';
import { NumberFormField } from './NumberFormField';
import { PercentFormField } from './PercentFormField';
import { TextFormField } from './TextFormField';
import { TreeSelect } from './TreeSelect';

export const DynamicFormField = ({ fieldDef }) => {
  const { tabLabel } = useTab();

  const fieldTypeToFormField = {
    CODE: CodeFormField,
    NUMBER: NumberFormField,
    BOOLEAN: BooleanSelect,
    ENUM: EnumSelect,
    DATE: DateFormField,
    INSTANT: InstantFormField,
    HYPERLINK: EntitySelect,
    ENTITY_ENUM: EnumSelect,
    MONEY: MoneyFormField,
    DROPDOWN: DropdownSelect,
    TREE: TreeSelect,
    PERCENT: PercentFormField,
  };

  // TextFormField is the default
  let FormFieldComponent = fieldTypeToFormField[fieldDef.type] ?? TextFormField;

  // In the info tab, code should use CodeFormField instead of Hyperlink
  if (fieldDef.field === 'code' && (tabLabel === 'Info' || tabLabel === null)) {
    FormFieldComponent = CodeFormField;
  }

  return <FormFieldComponent id={fieldDef.name} fieldDef={fieldDef} />;
};
